import React from 'react';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { classNames } from '@philips-internal/oswald-ui-utils';
import { ReactComponent as ArrowDownIcon } from '../../../resources/assets/components/DLS_NavigationDown.svg';
import { CollapseArrowDirection } from './collapse-arrow-constants.js';
import './collapse-arrow.css';
function CollapseArrow(props) {
    const { className, collapsed, direction = CollapseArrowDirection.DOWN, onClick } = props;
    const collapseRotation = 180;
    const iconMainRotation = {
        [CollapseArrowDirection.DOWN]: 0,
        [CollapseArrowDirection.LEFT]: 270,
        [CollapseArrowDirection.RIGHT]: 90,
        [CollapseArrowDirection.UP]: 180,
    };
    const rotation = collapsed
        ? iconMainRotation[direction]
        : (iconMainRotation[direction] + collapseRotation);
    const iconProps = {
        className: 'c-collapse-arrow-icon',
        style: { transform: `rotate(${rotation}deg)` },
    };
    const classes = classNames({
        'c-collapse-arrow': true,
        [`${className}`]: Boolean(className),
    });
    return (React.createElement("div", { "aria-label": MessageService.translate('tws.collapse-arrow.aria-label'), className: classes, "data-testid": "collapse-arrow", onClick: onClick, role: "button" },
        React.createElement(ArrowDownIcon, { ...iconProps })));
}
export { CollapseArrow, };
export default CollapseArrow;
//# sourceMappingURL=collapse-arrow.js.map